export const IMPORT_CHECKLIST = [
  "costing.restrictions.fileExtension",
  "costing.restrictions.headerRow",
  "costing.restrictions.columnRestriction",
];
